import {
    IconButton,
    InputAdornment,
    TextFieldProps,
    TextField,
} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import clsx from 'clsx';
import React, {useState} from 'react';
import useStyles from './InputStyles';
import {CustomInputChangeEvent} from '../../../types/common';

type Props = {
    onChange?: (e: CustomInputChangeEvent) => void;
    errorText?: string;
    helperText?: string;
    type?: string;
    label?: string;
} & Omit<
    TextFieldProps,
    'onChange' | 'type' | 'label' | 'helperText' | 'error' | 'variant'
>;

const CustomInput = ({
    onChange,
    errorText,
    helperText,
    type,
    className,
    label,
    InputProps,
    ...props
}: Props) => {
    const [passwordVisible, setPasswordVisible] = useState<boolean>(false);
    const classes = useStyles();
    const handleChange: TextFieldProps['onChange'] = event => {
        onChange?.(event as CustomInputChangeEvent);
    };

    return (
        <TextField
            label={label}
            variant="outlined"
            type={!passwordVisible && type === 'password' ? 'password' : 'text'}
            onChange={handleChange}
            error={!!errorText}
            helperText={errorText || helperText}
            className={className}
            InputProps={{
                ...InputProps,
                className: clsx(classes.container, className),
                endAdornment:
                    type === 'password' ? (
                        <InputAdornment
                            position="end"
                        >
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() =>
                                    setPasswordVisible(!passwordVisible)
                                }
                                edge="end"
                            >
                                {passwordVisible ? (
                                    <Visibility />
                                ) : (
                                    <VisibilityOff />
                                )}
                            </IconButton>
                        </InputAdornment>
                    ) : undefined,
            }}
            {...props}
        />
    );
};

export default CustomInput;
